<template>
  <div class="oil-sample-report" v-if="!isLoading">
    <header class="section">
      <div class="logo">
        <img class="logo-image" :src="sampleData.company.logoPath" alt="logo" />
      </div>
      <Severity :severityCode="sampleData.currentOilSample.sampleSeverityCode" />
    </header>
    <ContextualInfo :sampleData="sampleData" />
    <div class="section main-content">
      <div class="sample-info">
        <SampleInfoMetals :sampleData="sampleData" />
        <Analysis :sampleData="sampleData" />
        <ParticleCount :sampleData="sampleData" />
      </div>
    </div>
    <footer class="section">
      <p class="company-address">{{ sampleData.company.address | formatAddress }}</p>
      <h5 class="report-title">Lubricating Oil Analysis Report</h5>
    </footer>
  </div>
</template>

<script>
// Services
import GridDataService from 'services/grid-data.service';

// Constants
import Constants from '../../../constants/constants';

// Components
import Severity from './OilSampleReportSeverity.vue';
import ContextualInfo from './OilSampleReportContextualInfo.vue';
import SampleInfoMetals from './OilSampleReportSampleInfoMetals.vue';
import Analysis from './OilSampleReportAnalysis.vue';
import ParticleCount from './OilSampleReportParticleCount.vue';

export default {
  name: 'OilSampleReport',
  filters: {
    formatAddress(value) {
      if (!value) {
        return;
      }

      return value.trim().replace(/\r*\n/g, ' | ');
    }
  },
  components: {
    Severity,
    ContextualInfo,
    SampleInfoMetals,
    Analysis,
    ParticleCount
  },
  data() {
    return {
      elementList: Constants.SampleReport.Element.oilSampleElements,
      isLoading: true,
      sampleData: [],
      severity: 1
    };
  },
  mounted() {
    const queryString = new URLSearchParams(window.location.search);
    const id = parseInt(queryString.get('id'), 10);

    if (!id) {
      window.alert('The ID given does not exist or none was provided. Please try again.');

      return;
    }

    GridDataService.getReportData({
      apiUrl: Constants.Api.Endpoint.OilSample.reportApi,
      params: {
        id
      }
    }).then(({ data }) => {
      this.sampleData = data;
      this.isLoading = false;
    });
  }
};
</script>
